<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_IMAGE" ppColor="primary-950"></pp-icon>
</div>

@if (isNewImage) {
  @if (isSingleImageAdded) {
    <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
    {{ 'an' | ppTranslate }}
    <span class="notification__bold">{{ 'image_uppercase' | ppTranslate }}</span>
    {{ 'to_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
  @if (isMultipleImagesAdded) {
    <span class="notification__blue-text">{{ 'added' | ppTranslate }}</span>
    {{
    ppNotification.changeBody.oldValue
    ? ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length
    : ppNotification.changeBody.newValue.length
    }}
    <span class="notification__bold">{{ 'images_uppercase' | ppTranslate }}</span>
    {{ 'to_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
}

@if (!isNewImage) {
  @if (isSingleImageRemoved) {
    <span class="notification__blue-text">{{ 'removed' | ppTranslate }}</span>
    {{ 'an' | ppTranslate }}
    <span class="notification__bold">{{ 'image_uppercase' | ppTranslate }}</span>
    {{ 'from_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
  @if (isMultipleImagesRemoved) {
    <span class="notification__blue-text">{{ 'removed' | ppTranslate }}</span>
    {{
    ppNotification.changeBody.oldValue
    ? ppNotification.changeBody.newValue.length - ppNotification.changeBody.oldValue.length
    : ppNotification.changeBody.newValue.length
    }}
    <span class="notification__bold">{{ 'images_uppercase' | ppTranslate }}</span>
    {{ 'from_a_point_you' | ppTranslate }}
    {{ notificationReason }}.
  }
}
